import React from 'react';
import Select from 'react-select';
import FormInputFields from '../../../Components/FormInputFields';
import { ErrorBlock } from '../../../hoc/FormInput';
import { isSet } from '../../../Utils/CommonFunctions';

const VersionDetail = (props) => {
   const {changeHandler, versionNumericChangeHandler, addonDetail, addonList, valueChangeHandler, validationErrors} = props;
   const {version, price, discount, description, feature, dependent_id} = addonDetail.version_details;
   const versionError = validationErrors ? validationErrors.version : null;
   const priceErr = validationErrors && validationErrors.price;
   const discountErr = validationErrors && validationErrors.discount;

   const priceDisplay = price === null || price === undefined ? '' : String(price);
   const discountDisplay = discount === null || discount === undefined ? '' : String(discount);

   const numericFields = [
      {
         type: 'Decimal',
         fieldId: 'price',
         label: 'Price',
         value: priceDisplay,
         col: 'col-6',
         isAllowNegative: true,
         attributes: {
            id: 'addon_version_price',
            name: 'price',
            decimal: 2,
            className: 'form-control',
         },
         changeHandler: (val) => versionNumericChangeHandler('price', val),
      },
      {
         type: 'Percentage',
         fieldId: 'discount',
         label: 'Discount',
         value: discountDisplay,
         col: 'col-6',
         max: 3,
         decimal: 0,
         attributes: {
            id: 'addon_version_discount',
            name: 'discount',
            className: 'form-control',
         },
         changeHandler: (val) => versionNumericChangeHandler('discount', val),
      },
   ];

	return (
		<div className="tab-pane fade" id="tab2">
            <div className="row">
               <div className="col-6 ">
                  <div className="form-group">
                     <label>Version Name</label>
                     <input 
                        type="text" 
                        className={`form-control mandatory ${versionError && versionError.isError ? 'is-invalid' : ''}`} 
                        value={version} 
                        name="version" 
                        onChange={changeHandler} 
                     />
                     {versionError && versionError.isError && (
                        <div className="invalid-feedback" style={{display: 'block'}}>
                           {versionError.error}
                        </div>
                     )}
                  </div>
               </div> 
                <div className="col-6 ">
                  <div className="form-group">
                     <label> Dependency  </label>
                     <Select
                        classNamePrefix="form-control"
                        value={dependent_id}
                        isMulti
                        onChange={e=>valueChangeHandler(e,"dependent_id","version")}
                        options={addonList}
                     />
                  </div>
               </div>
               {numericFields.map((item, itemIndex) => {
                  const fieldError = item.fieldId === 'price' ? priceErr : discountErr;
                  const errMsg = fieldError && fieldError.isError ? fieldError.error : '';
                  return (
                     <div className={item.col} key={item.fieldId || itemIndex}>
                        <div className="form-group">
                           <label>{item.label}</label>
                           <FormInputFields {...item} />
                           <ErrorBlock message={isSet(errMsg, '')} />
                        </div>
                     </div>
                  );
               })}
            </div>

            <div className="row">
               <div className="col-6">
                  <div className="form-group">
                     <label>Short Description</label>
                     <textarea className="form-control" value={description} name="description" onChange={changeHandler}></textarea>
                  </div>
               </div>
               <div className="col-6">
                  <div className="form-group">
                     <label>Features</label>
                     <textarea className="form-control" value={feature} name="feature" onChange={changeHandler}></textarea>
                  </div>
               </div>
            </div>
         </div>
	)
}

export default VersionDetail;
